import * as vp from 'vopay';
import dynamicsBusinessCentral from './svgs/dynamicsBusinessCentral.svg';
import freshbooks from './svgs/freshbooks.svg';
import oracleNetsuite from './svgs/oracleNetsuite.svg';
import quickbooks from './svgs/quickbooks.png';
import sageBusinessCloud from './svgs/sageBusinessCloud.svg';
import sageIntacct from './svgs/sageIntacct.svg';
import wave from './svgs/wave.svg';
import xero from './svgs/xero.svg';

export const AccountingImageMap: { [key in vp.RailzServiceNames]: { src: string; alt: string } } = {
  dynamicsBusinessCentral: {
    src: dynamicsBusinessCentral,
    alt: 'dynamicsBusinessCentral',
  },
  freshbooks: {
    src: freshbooks,
    alt: 'freshbooks',
  },
  oracleNetsuite: {
    src: oracleNetsuite,
    alt: 'oracleNetsuite',
  },
  quickbooks: {
    src: quickbooks,
    alt: 'quickbooks',
  },
  sageBusinessCloud: {
    src: sageBusinessCloud,
    alt: 'sageBusinessCloud',
  },
  sageIntacct: {
    src: sageIntacct,
    alt: 'sageIntacct',
  },
  wave: {
    src: wave,
    alt: 'wave',
  },
  xero: {
    src: xero,
    alt: 'xero',
  },
};
